import { getFormattedDate, sanitizeUrl } from "../helpers";
import { API__ChainNews } from "./api/ChainNews";

export interface iChainNews {
    title: string;
    date: string;
    url: string;
    description: string;
    isReportProNews: boolean;
}

export class ChainNews implements iChainNews {
    static defaultData: iChainNews = {
        title: "",
        date: "",
        url: "",
        description: "",
        isReportProNews: false,
    }

    title = ChainNews.defaultData.title;
    date = ChainNews.defaultData.date;
    url = ChainNews.defaultData.url;
    description = ChainNews.defaultData.description;
    isReportProNews = ChainNews.defaultData.isReportProNews;

    constructor(data: API__ChainNews) {
        if ( data ) {
            this.mapFromApi(data);
        }
    }

    private mapFromApi(data: API__ChainNews) {
        this.setDate({
            title: data.title || ChainNews.defaultData.title,
            date: data.createdOnDate ? getFormattedDate(data.createdOnDate, "MM/DD/YY") : ChainNews.defaultData.date,
            url: sanitizeUrl(data.source || ChainNews.defaultData.url),
            description: data.description || ChainNews.defaultData.description,
            isReportProNews: data.isReportProNews ?? ChainNews.defaultData.isReportProNews,
        })
    }

    private setDate(model: iChainNews) {
        ({
            title: this.title,
            date: this.date,
            url: this.url,
            description: this.description,
            isReportProNews: this.isReportProNews,
        } = model);
    }
}